import { render, staticRenderFns } from "./servieItemDetailAll.vue?vue&type=template&id=17d40e85&"
import script from "./servieItemDetailAll.vue?vue&type=script&lang=ts&"
export * from "./servieItemDetailAll.vue?vue&type=script&lang=ts&"
import style0 from "./servieItemDetailAll.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports